import { useQuery } from "react-query";
import { getOneTalentCategory } from "services/talentCategories.service";

export default function useTalentCategory(id) {
  return useQuery(
    ["talentCategories", id],
    async () => await getOneTalentCategory(id)
  );
}
